import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { TemplateState } from '../states/template.state';

export const selectTemplateFeature = (state: AppState) => state.template;

export const setTemplates = createSelector(
    selectTemplateFeature,
    (state: TemplateState) => state.templates
  );

export const setSelectedTemplate = createSelector(
    selectTemplateFeature,
    (state: TemplateState) => state.selectedTemplate
  );

export const setListStatus = createSelector(
    selectTemplateFeature,
    (state: TemplateState) => state.listStatus
);

export const setGetStatus = createSelector(
  selectTemplateFeature,
  (state: TemplateState) => state.getStatus
);

export const setUpdateStatus = createSelector(
  selectTemplateFeature,
  (state: TemplateState) => state.updateStatus
);

export const setCreateStatus = createSelector(
  selectTemplateFeature,
(state: TemplateState) => state.createStatus
);

export const setDeleteStatus = createSelector(
  selectTemplateFeature,
(state: TemplateState) => state.deleteStatus
);

/* export const selectTemplate = createSelector(
    selectTemplateFeature, (state: TemplateState) => state
) */